'use strict';

var _extends = require('./extends-733dd656.js');
var xstyledStyledComponents_es = require('./xstyled-styled-components.es-6e2bde7d.js');
var styles_breakpoints = require('./breakpoints-ee0a4ae5.js');
var colorBuilder = require('./colorBuilder-8c1a81a8.js');

var DEFAULT_SPACE = {
  '0x': 0,
  '1x': 4,
  '2x': 8,
  '3x': 12,
  '4x': 16,
  '5x': 20,
  '6x': 24,
  '8x': 32,
  '12x': 48,
  '16x': 64,
  '20x': 80,
  '24x': 96,
  '28x': 112,
  '32x': 128,
  '36x': 144,
  '40x': 160
};
var spacing = function spacing(nudsTheme) {
  for (var _len = arguments.length, spacingValues = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    spacingValues[_key - 1] = arguments[_key];
  }

  return spacingValues.reduce(function (spacingString, spacingValue) {
    return "".concat(spacingString, " ").concat(xstyledStyledComponents_es.th.space(spacingValue)({
      theme: nudsTheme
    }));
  }, '').trim();
};

var baseColors = {
  violetDark: '#820AD1',
  violetHeliotrope: '#AB4BEA',
  violetIndigo: '#4C0677',
  violetMauve: '#9C63C0',
  black: '#111111',
  grayNero: '#191919',
  grayWhiteSmoke: '#F5F5F5',
  white: '#FFFFFF',
  greenDarkSpring: '#1F7F45',
  greenJungle: '#2DB965',
  redAlizarin: '#D72923',
  redGeraldine: '#E9807C',
  orangeTenne: '#EF6C00',
  orangeNeonCarrot: '#FF943D',
  blueSurfie: '#00737B',
  blueIris: '#00BBC8'
};
var brand = {
  "default": baseColors.violetDark,
  light: baseColors.violetHeliotrope,
  defaultL40: '#CF8CFC',
  defaultL20: '#E0C2FF',
  defaultL10: '#F4E7FF'
};
var products = {
  conta: brand,
  creditCard: brand,
  rewards: brand,
  pj: {
    "default": baseColors.violetIndigo,
    light: baseColors.violetMauve,
    defaultL40: '#C39BDC',
    defaultL20: '#E1CAF0',
    defaultL10: '#F4EAFB'
  }
};
var grayscale = {
  black: colorBuilder.colorBuilder(baseColors.black, {
    light: baseColors.grayNero
  }, {
    includeDefaultTransparency: true
  }),
  white: colorBuilder.colorBuilder(baseColors.white, {
    dark: baseColors.grayWhiteSmoke
  }, {
    includeDefaultTransparency: true
  })
};
var utility = {
  success: colorBuilder.colorBuilder(baseColors.greenDarkSpring, {
    light: baseColors.greenJungle
  }),
  error: colorBuilder.colorBuilder(baseColors.redAlizarin, {
    light: baseColors.redGeraldine
  }),
  warning: colorBuilder.colorBuilder(baseColors.orangeTenne, {
    light: baseColors.orangeNeonCarrot
  }),
  info: colorBuilder.colorBuilder(baseColors.blueSurfie, {
    light: baseColors.blueIris
  })
};

var colors = _extends._extends_1({
  brand: brand,
  primary: brand
}, utility, products, grayscale);

var zIndexes = {
  jumpToContent: 9999
};
var gutter = {
  mobileSmall: 16,
  mobile: 24,
  tablet: 24,
  desktop: 32,
  desktopLarge: 32
};
var margin = {
  mobileSmall: 24,
  mobile: 24,
  tablet: 40,
  desktop: 56,
  desktopLarge: 56
};
var typography = [{
  fontFamily: 'Graphik-Regular',
  sources: [{
    url: 'https://cdn.nubank.com.br/fonts/Graphik/variants/Graphik-Regular.woff2',
    format: 'woff2'
  }, {
    url: 'https://cdn.nubank.com.br/fonts/Graphik/variants/Graphik-Regular.woff',
    format: 'woff'
  }, {
    url: 'https://cdn.nubank.com.br/fonts/Graphik/variants/Graphik-Regular.ttf',
    format: 'truetype'
  }, {
    url: 'https://cdn.nubank.com.br/fonts/Graphik/variants/Graphik-Regular.svg#Graphik-Regular',
    format: 'svg'
  }, {
    url: 'https://cdn.nubank.com.br/fonts/Graphik/variants/Graphik-Regular.eot?#iefix',
    format: 'embedded-opentype'
  }]
}, {
  fontFamily: 'Graphik-Medium',
  sources: [{
    url: 'https://cdn.nubank.com.br/fonts/Graphik/variants/Graphik-Medium.woff2',
    format: 'woff2'
  }, {
    url: 'https://cdn.nubank.com.br/fonts/Graphik/variants/Graphik-Medium.woff',
    format: 'woff'
  }]
}];
var theme = {
  baseSpacingValue: 4,
  colors: colors,
  typography: typography,
  gutter: gutter,
  margin: margin,
  zIndexes: zIndexes,
  breakpoints: styles_breakpoints.DEFAULT_BREAKPOINTS,
  space: DEFAULT_SPACE
};

exports.gutter = gutter;
exports.margin = margin;
exports.products = products;
exports.spacing = spacing;
exports.theme = theme;
exports.typography = typography;
exports.zIndexes = zIndexes;
//# sourceMappingURL=theme-80c5a73f.js.map
